module.exports = __webpack_public_path__ + "img/GlobalRenaqua_200h.455b6c6a.png";